import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { accessRows, accessChecks } from '../../data/instantAccess';
export function InstantAccess() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-136" data-mp="39dq55tozbejc">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-137" data-mp="34c0s68i74qsm">
        <SectionTag icon="📦" data-id="element-138" data-mp="30bqnr0a1y8fv">Acceso inmediato</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-139" data-mp="30dbior0a3te9">
          Esto lo recibes en tu correo hoy mismo.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-140" data-mp="2qm73prals8jf">
          Recibes por correo el enlace de acceso a la colección digital: seis tomos y cinco bonos en PDF.
          Descárgalos, consúltalos en tu dispositivo o imprime las fichas que vayas a utilizar.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 sm:px-6" data-id="element-141" data-mp="2cmxmqpekpaee">
        <ScrollHintTable minWidth="420px" data-id="element-142" data-mp="35oyfhwcuin3g">
          <table className="w-full text-left text-sm" data-id="element-143" data-mp="35n3y2s0s9d44">
            <thead data-id="element-144" data-mp="3afx0vacoybdk">
              <tr className="border-b border-white/10 bg-white/5 text-xs uppercase tracking-wide text-muted" data-id="element-145" data-mp="3aggj6s6971s4">
                <th className="px-5 py-3 font-semibold" data-id="element-146" data-mp="2vrts5t79kll2">Contenido</th>
                <th className="px-5 py-3 font-semibold" data-id="element-147" data-mp="30p2f073cxdsn">Formato</th>
                <th className="px-5 py-3 font-semibold" data-id="element-148" data-mp="30n94ggpmi9fd">Extensión</th>
              </tr>
            </thead>
            <tbody data-id="element-149" data-mp="3te9aex7iln9o">
              {accessRows.map((row, i) => <tr key={row.content} className={i !== accessRows.length - 1 ? 'border-b border-white/5' : ''} data-id="element-150" data-mp="3tdhromz0nk0t" data-mpi={i}>
                  <td className="px-5 py-4 text-white" data-id="element-151" data-mp="3fgkp5o9jce43">{row.content}</td>
                  <td className="whitespace-nowrap px-5 py-4 text-muted" data-id="element-152" data-mp="3jesayxiuw5m5">{row.format}</td>
                  <td className="whitespace-nowrap px-5 py-4 font-semibold text-lime" data-id="element-153" data-mp="23yjnqtpqfmuz">{row.extension}</td>
                </tr>)}
            </tbody>
          </table>
        </ScrollHintTable>

        <p className="mt-4 text-center text-xs leading-relaxed text-muted sm:text-sm" data-id="element-154" data-mp="egw95rzavhf3">
          538 páginas en total, incluidas portadas y materiales reunidos en los bonos. Las sesiones
          seleccionadas en los bonos ya forman parte del inventario de los tomos.
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-155" data-mp="3vzgzy3artim7">
          {accessChecks.map(check => <div key={check} className="flex items-center gap-2 text-sm text-white" data-id="element-156" data-mp="3ryot1gpdfpt3">
              <CheckIcon size={16} className="text-success" data-id="element-157" data-mp="3mwzdpov48pz7" />
              {check}
            </div>)}
        </div>
      </div>
    </section>;
}